export interface StatusDefinition {
  label: string
  color: string
  phase: string
}

export const ALL_STATUSES: StatusDefinition[] = [
  // Phase d’Entrée (blue theme, except discard is red)
  { label: "Demande reçue", color: "blue", phase: "Phase d’Entrée" },
  { label: "Discarté", color: "red", phase: "Phase d’Entrée" },
  { label: "Suivi à faire", color: "blue", phase: "Phase d’Entrée" },
  {
    label: "Suivi fait - en attente de retour",
    color: "blue",
    phase: "Phase d’Entrée",
  },
  {
    label: "Visite planifiée",
    color: "yellow",
    phase: "Phase d’Analyse",
  },

  // Phase d’Analyse (yellow theme, except “Positif” is green, “À discuter” is orange)
  {
    label: "Enquête de crédit à faire",
    color: "yellow",
    phase: "Phase d’Analyse",
  },
  {
    label: "Enquête de crédit en cours",
    color: "yellow",
    phase: "Phase d’Analyse",
  },
  { label: "Positif", color: "green", phase: "Phase d’Analyse" },
  { label: "À discuter", color: "orange", phase: "Phase d’Analyse" },
  {
    label: "Suivi enquête de crédit à faire",
    color: "yellow",
    phase: "Phase d’Analyse",
  },

  // Phase d’Engagement (green)
  {
    label: "Montage du bail à faire",
    color: "green",
    phase: "Phase d’Engagement",
  },
  {
    label: "En attente de signature",
    color: "green",
    phase: "Phase d’Engagement",
  },
  { label: "Closed-Win", color: "green", phase: "Phase d’Engagement" },
]
